var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgEmployees = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#E6F4ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 23.25C30.8734 23.2493 31.7349 23.4524 32.516 23.843C33.2972 24.2335 33.9765 24.8009 34.5 25.5",
    stroke: "#07794C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 25.5C14.0235 24.8009 14.7028 24.2335 15.484 23.843C16.2651 23.4524 17.1266 23.2493 18 23.25",
    stroke: "#07794C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 29.25C26.0711 29.25 27.75 27.5711 27.75 25.5C27.75 23.4289 26.0711 21.75 24 21.75C21.9289 21.75 20.25 23.4289 20.25 25.5C20.25 27.5711 21.9289 29.25 24 29.25Z",
    stroke: "#07794C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 32.25C19.2884 31.3364 20.0559 30.579 20.9767 30.0529C21.8974 29.5267 22.9395 29.25 24 29.25C25.0605 29.25 26.1026 29.5267 27.0233 30.0529C27.9441 30.579 28.7116 31.3364 29.25 32.25",
    stroke: "#07794C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0938 19.5C27.234 18.9568 27.5238 18.4638 27.9302 18.077C28.3366 17.6902 28.8433 17.4251 29.3927 17.3118C29.9422 17.1985 30.5125 17.2416 31.0387 17.4361C31.5649 17.6306 32.0261 17.9688 32.3697 18.4123C32.7134 18.8557 32.9258 19.3867 32.9829 19.9448C33.04 20.5029 32.9394 21.0659 32.6926 21.5697C32.4458 22.0735 32.0627 22.4981 31.5867 22.7951C31.1108 23.0921 30.561 23.2497 30 23.25",
    stroke: "#07794C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18 23.25C17.4389 23.2497 16.8892 23.0921 16.4132 22.7951C15.9373 22.4981 15.5541 22.0735 15.3073 21.5697C15.0605 21.0659 14.96 20.5029 15.017 19.9448C15.0741 19.3867 15.2865 18.8557 15.6302 18.4123C15.9739 17.9688 16.435 17.6306 16.9613 17.4361C17.4875 17.2416 18.0577 17.1985 18.6072 17.3118C19.1567 17.4251 19.6634 17.6902 20.0698 18.077C20.4762 18.4638 20.7659 18.9568 20.9062 19.5",
    stroke: "#07794C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEmployees, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/employees.c5a78af5.svg";
export { ForwardRef as ReactComponent };